import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const StyledLi = styled.li`
    input:focus + label {
        outline:0.25rem solid #2491ff;
    }   
`;

const RadioButton = props => {
    const {
        inputData: {
            id,
            name,
            inputClass,
            liClass,
            value,
            checked
        },
        label: {
            labelText,
            labelClass,
            showRequiredIcon,
            text = undefined,
            textClassName
        },
        actions: {
            handleFieldChange
        }
    } = props;

    const keyPress = e => {
        const isEnterOrSpace = e.key === ' ' || e.key === 'SpaceBar' || e.key === 'Enter' || e.keyCode === 32 || e.keyCode === 13;
        if (isEnterOrSpace) {
            handleFieldChange(e);
        }
    };

    const handleValueChange = () => {
        handleFieldChange({ target: { name, value } });
    };

    const label = text ? <span className={`${textClassName && textClassName.join(' ')}`}> {text} </span>
        : <FormattedMessage id={labelText} />;

    return (
        <Fragment>
            <StyledLi className={`${liClass && liClass.join(' ')}`}>
                <input
                    id={id}
                    data-automation-id={id}
                    name={name}
                    className={`usa-radio__input gi-radio_buttons__input ${inputClass && inputClass.join(' ')}`}
                    type="radio"
                    checked={checked}
                    tabIndex="0"
                    role="radio"
                    aria-checked={checked}
                    data-value={value}
                    aria-labelledby={id}
                    onKeyPress={keyPress}
                    onChange={handleValueChange}
                />
                <label
                    className={`usa-radio__label gi-radio_buttons__label ${labelClass && labelClass.join(' ')} required-${showRequiredIcon}`}
                    htmlFor={id}
                    onClick={handleValueChange}
                    data-value={value}>
                    {label}
                </label>
            </StyledLi>
        </Fragment>
    );
};

export default RadioButton;